import PropTypes from 'prop-types';
import React from 'react';
import ReceiptTax from 'components/receipt/commons/CountingBox/ReceiptTax';
import Subtotal from 'components/receipt/commons/CountingBox/Subtotal';
import Gratuity from 'components/receipt/commons/CountingBox/Gratuity';
import Rounding from 'components/receipt/commons/CountingBox/Rounding';
import styles from './RefundCountingBox.css';

class RefundCountingBox extends React.Component {
  render() {
    const { paymentDetail, paymentRefund } = this.props;
    // noinspection JSUnresolvedVariable
    return (
      paymentRefund.is_refund_breakdown && (
        <div className={styles['refund-counting-box']}>
          <Subtotal subtotal={this.calculateSubTotal(paymentRefund)} />
          {paymentDetail.enable_gratuity && (
            <Gratuity
              gratuities={paymentRefund.payment_gratuities}
              includeGratuityTax={paymentDetail.include_gratuity_tax}
            />
          )}

          {paymentDetail.enable_tax && (
            <ReceiptTax
              taxes={paymentRefund.payment_taxes}
              includeGratuityTax={paymentDetail.include_gratuity_tax}
            />
          )}

          {Boolean(parseInt(paymentRefund.total_rounding_amount)) && (
            <Rounding
              totalRoundingAmount={paymentRefund.total_rounding_amount}
            />
          )}
        </div>
      )
    );
  }

  calculateSubTotal = paymentDetail => {
    let subtotal = 0;
    const { checkouts } = paymentDetail;

    if (checkouts.length > 0) {
      for (let x = 0; x < checkouts.length; x++) {
        const checkoutDiscounts = checkouts[x].discounts;
        let totalDiscounts = 0;

        for (let y = 0; y < checkoutDiscounts.length; y++) {
          totalDiscounts += parseFloat(checkoutDiscounts[y].discount_amount);
        }

        subtotal += checkouts[x].price - totalDiscounts;
      }
    } else {
      for (const salesType in checkouts) {
        for (let x = 0; x < checkouts[salesType].length; x++) {
          const checkoutDiscounts = checkouts[salesType][x].discounts;
          let totalDiscounts = 0;

          for (let y = 0; y < checkoutDiscounts.length; y++) {
            totalDiscounts += parseFloat(checkoutDiscounts[y].discount_amount);
          }
          subtotal += checkouts[salesType][x].price - totalDiscounts;
        }
      }
    }

    const paymentDiscounts = paymentDetail.payment_discounts;

    for (let x = 0; x < paymentDiscounts.length; x++) {
      subtotal -= paymentDiscounts[x].discount_amount;
    }

    subtotal -= paymentDetail.total_redeem_amount;

    // Calculate subtotal with promo
    let currentSubtotal = Math.abs(subtotal); // Need to temp current subtotal and absolute it so that promo can just minus it
    if (paymentDetail.promos) {
      paymentDetail.promos.forEach(promo => {
        promo.items.forEach(item => {
          for (const salesType in checkouts) {
            checkouts[salesType].forEach(checkout => {
              if (checkout.id === item.checkout_id) {
                currentSubtotal -= Math.abs(
                  (item.total_rewarded / item.amount) * checkout.quantity
                );
              }
            });
          }
        });
      });
    }

    return -currentSubtotal;
  };
}

RefundCountingBox.propTypes = {
  paymentDetail: PropTypes.object,
  paymentRefund: PropTypes.object,
};

export default RefundCountingBox;
